// Traduções (Arquitetura: i18next, arquivos en e pt-BR — nenhum texto fixo no código, P-005).
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import type { Language } from '../domain/settings';
import de from './de.json';
import en from './en.json';
import es from './es.json';
import fr from './fr.json';
import it from './it.json';
import ptBR from './pt-BR.json';
import ptPT from './pt-PT.json';
// Termos de Uso e Política de Privacidade (AC-088) — namespace "legal", por enquanto só em
// pt-BR e en: pt-PT mostra o pt-BR e os demais idiomas mostram o inglês (ASM-044)
import legalEn from './legal/en.json';
import legalPtBR from './legal/pt-BR.json';

export const resources = {
  en: { translation: en, legal: legalEn },
  'pt-BR': { translation: ptBR, legal: legalPtBR },
  'pt-PT': { translation: ptPT },
  es: { translation: es },
  fr: { translation: fr },
  de: { translation: de },
  it: { translation: it },
} as const;

export function initI18n(lng: Language) {
  if (!i18n.isInitialized) {
    void i18n.use(initReactI18next).init({
      resources,
      lng,
      // pt-PT sem texto (só os legais, por enquanto) usa o pt-BR antes do inglês
      fallbackLng: { 'pt-PT': ['pt-BR', 'en'], default: ['en'] },
      interpolation: { escapeValue: false },
      returnNull: false,
    });
  } else if (i18n.language !== lng) {
    void i18n.changeLanguage(lng);
  }
  return i18n;
}

export { i18n };
